<template>
  <common-dialog
    ref="dialog"
    ok-text="Confirm"
    :width="30"
    :hasFooter="true"
    :inputs-map="inputs"
    :resetInputs="resetStage"
    :save-cb="changeShipmentStage"
    title="Change Staging Area"
  >
    <template v-slot:content>
      <div class="f-c pallet-info">
        <div class="f-r" style="width: 100%">
          <div class="f-c summary">
            <span class="title bold-oswald">Total Pallets</span>
            <span class="value light-oswald">{{ totalPalletCount }}</span>
          </div>
          <div class="f-c summary">
            <span class="title bold-oswald">Checked Pallets</span>
            <span class="value light-oswald">{{ checkedPalletCount }}</span>
          </div>
        </div>
        <div class="hint f-c">
          <span> 1. Prepared pallets will be OffStack. </span>
          <span> 2. Clear stage by leaving select empty! </span>
        </div>
      </div>
    </template>
  </common-dialog>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// api
import { changeStageArea } from '@/api/shipment'
// models
import { ShipmentStageForm } from '@/core/models/shipment'
// message
import PagesMessage from '@/core/message/pages'
export default {
  name: 'ChangePort',
  components: {
    CommonDialog
  },
  props: {
    shipment: {
      type: Object
    }
  },
  data() {
    return {
      inputs: cloneDeep(ShipmentStageForm),
      portSelected: ''
    }
  },
  computed: {
    shipmentNo() {
      return this.shipment?.no ?? ''
    },
    totalPalletCount() {
      return this.shipment?.palletIds?.length ?? 0
    },
    checkedPalletCount() {
      return this.shipment?.loadedPalletIds?.length ?? 0
    },
    shipmentId() {
      return this.shipment?.id ?? ''
    },
    formStageNo() {
      return this.inputs[1].value
    },
    forceChange() {
      return this.inputs[2].value
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open()
      this.inputs[0].value = this.shipmentNo
      this.inputs[1].value = this.shipment?.stageNo ?? ''
    },
    confirm() {
      this.changeShipmentStage()
    },
    cancel() {},
    resetStage() {
      this.inputs[1].value = this.shipment?.stageNo ?? ''
    },
    changeShipmentStage(_, done, error) {
      if (this.formStageNo === this.shipment.stageNo) {
        error('Stage not changed')
        return
      }
      changeStageArea(this.shipmentId, this.formStageNo, this.forceChange)
        .then(res => {
          this.$message.success('Successfully changed stage port!')
          done()
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
        })
        .catch(err => error(err.toString()))
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.pallet-info {
  margin-bottom: 24px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  padding: 10px 0;

  .summary {
    width: 50%;
    justify-content: center;
    font-size: 24px;

    span {
      text-align: center;
    }

    .value {
      font-size: 36px;
    }
  }

  .hint {
    gap: 5px;
    padding: 0 10px;
    padding-top: 10px;
    color: rgba($deep-danger, 0.6);
    word-break: break-word;
  }
}
</style>
